// helpers/roleUtils.js

// ✅ General: Comprueba si el objeto (user o athlete.user) tiene un rol
export function hasRole(subject, roleName) {
    const roles = subject?.roles || subject?.user?.roles || [];
    return roles.some(role => role.name === roleName);
}

// ✅ Roles individuales
export function isOrganizer(subject) {
    return hasRole(subject, 'Organizer');
}

export function isSupervisor(subject) {
    return hasRole(subject, 'Supervisor');
}

export function isJudge(subject) {
    return hasRole(subject, 'Judge');
}

export function isAthlete(subject) {
    return hasRole(subject, 'Athlete');
}

// ✅ Comprobación de propiedad como ORGANIZADOR de la competencia
export function isOwnerOrganizer(user, competition) {
    const userId = Number(user?.id ?? user?.user?.id);
    if (!Number.isFinite(userId)) return false;

    const organizerId = Number(competition?.organizer_id ?? competition?.organizer?.id);
    if (Number.isFinite(organizerId) && userId === organizerId) {
        return true;
    }

    const coOrganizers = Array.isArray(competition?.co_organizers)
        ? competition.co_organizers
        : [];
    const competitionUsers = Array.isArray(competition?.competition_users)
        ? competition.competition_users
        : [];

    const approvedDirectCoOrganizer = coOrganizers.some(entry => {
        const statusId = Number(entry?.status_id ?? entry?.status?.id ?? entry?.pivot?.status_id);
        const entryUserId = Number(entry?.user_id ?? entry?.user?.id ?? entry?.id);
        return statusId === 4 && entryUserId === userId;
    });

    if (approvedDirectCoOrganizer) {
        return true;
    }

    const approvedCompetitionUserCoOrganizer = competitionUsers.some(entry => {
        const roleId = Number(entry?.role_id ?? entry?.pivot?.role_id);
        const statusId = Number(entry?.status_id ?? entry?.status?.id ?? entry?.pivot?.status_id);
        const entryUserId = Number(entry?.user_id ?? entry?.user?.id);
        return roleId === 3 && statusId === 4 && entryUserId === userId;
    });

    return approvedCompetitionUserCoOrganizer;
}

// ✅ Comprobación de propiedad como ATHLETE (athlete es competition_user)
export function isOwnerAthlete(user, athleteEntry) {
    return user?.id === athleteEntry?.user?.id;
}
export function isInnerAthlete(user, athleteEntry) {
    const userId = user?.id ?? user?.user?.id;
    const athleteUserId = athleteEntry?.user?.id ?? athleteEntry?.user_id ?? athleteEntry?.id;
    if (userId == null || athleteUserId == null) return false;
    return Number(userId) === Number(athleteUserId);
}
export function isOwnerJudge(user, judgeEntry) {
    return user?.id === judgeEntry?.user?.id;
}
export function isOwnerJudgeFromCompetition(user, competition) {
    if (!competition || !Array.isArray(competition.competition_users)) {
        return false;
    }
    return competition.competition_users.some(entry =>
        entry.role_id === 2 && entry.user?.id === user?.id
    );
}

// ✅ Comprobación compuesta para saber si es Organizer, Judge o Athlete
export function hasAnyRole(subject, roles = []) {
    return roles.some(role => hasRole(subject, role));
}

// Ejemplo de uso:
// isOwnerAthlete(currentUser, athlete)
// isOrganizer(currentUser)
// isJudge(athlete)
// hasAnyRole(currentUser, ['Judge', 'Organizer'])
